// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__d-i3n","hideHeader":"layout_hideHeader__3JyNo","grey":"layout_grey__2VeN4","bodyClass":"layout_bodyClass__14wqR"};